import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Add this import
import { getValue } from "@utils/lodash";
import SingleSelectSearchDropdown from "@components/common/CustomSearchableDropdown/SingleSelectSearchDropdown";
import { getUserDelegate, updateUserDelegate } from "@services/users.service";
import { toast } from "react-toastify";
import AdminNavigation from "@components/Admin/admin-navigation";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
interface RouteParams {
  id: string;
}
function UserDelegation(props: any) {
  const [isApplyDelegationAllowed, setIsApplyDelegationAllowed] =
    useState(false);
  const [isApprovalDelegationAllowed, setIsApprovalDelegationAllowed] =
    useState(false);
  const [isTravelDocumentDelegationAllowed, setIsTravelDocumentDelegationAllowed] =
    useState(false);
  const [isTravelProfileDelegationAllowed, setIsTravelProfileDelegationAllowed] =
    useState(false);
  const [selectedApplyUser, setSelectedApplyUser] = useState<any>(null);
  const [selectedApprovalUser, setSelectedApprovalUser] = useState<any>(null);
  const [selectedTravelDocumentUser, setSelectedTravelDocumentUser] =
    useState<any>(null);
  const [selectedTravelProfileUser, setSelectedTravelProfileUser] =
    useState<any>(null);
  const [applyUsers, setApplyUsers] = useState<any[]>([]);
  const [approvalUsers, setApprovalUsers] = useState<any[]>([]);
  const [travelDocumentUsers, setTravelDocumentUsers] = useState<any[]>([]);
  const [travelProfileUsers, setTravelProfileUsers] = useState<any[]>([]);
  const [applyLoading, setApplyLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [travelDocumentLoading, setTravelDocumentLoading] = useState(false);
  const [travelProfileLoading, setTravelProfileLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Get user ID from React Router params
  const params = useParams() as RouteParams;
  const userId = params.id;

  useEffect(() => {
    if (userId) {
      fetchDelegationSettings();
    } else {
    }
  }, [userId]);

  const fetchDelegationSettings = async () => {
    try {
      const response = await getUserDelegate(userId);

      if (response && getValue(response, "data", null)) {
        const delegationData = getValue(response, "data", {});

        // Apply delegation settings
        const isApplyAllowed = getValue(
          delegationData,
          "is_apply_delegation_active",
          false
        );
        const applyDelegatedTo = getValue(
          delegationData,
          "apply_delegated_to",
          null
        );

        // Approval delegation settings
        const isApprovalAllowed = getValue(
          delegationData,
          "is_approval_delegation_active",
          false
        );
        const approvalDelegatedTo = getValue(
          delegationData,
          "approval_delegated_to",
          null
        );

        // Travel document delegation settings
        const isTravelDocumentAllowed = getValue(
          delegationData,
          "is_travel_document_delegation_active",
          false
        );
        const travelDocumentDelegatedTo = getValue(
          delegationData,
          "travel_document_delegated_to",
          null
        );
        const isTravelProfileAllowed = getValue(
          delegationData,
          "is_travel_profile_delegation_active",
          false
        );
        const travelProfileDelegatedTo = getValue(
          delegationData,
          "travel_profile_delegated_to",
          null
        );

        setIsApplyDelegationAllowed(isApplyAllowed);
        setIsApprovalDelegationAllowed(isApprovalAllowed);
        setIsTravelDocumentDelegationAllowed(isTravelDocumentAllowed);
        setIsTravelProfileDelegationAllowed(isTravelProfileAllowed);

        if (isApplyAllowed && applyDelegatedTo) {
          const userId =
            typeof applyDelegatedTo === "object"
              ? getValue(applyDelegatedTo, "id", "")
              : applyDelegatedTo;
          setSelectedApplyUser(userId);

          // Create a user object from the response data for prefilling
          if (typeof applyDelegatedTo === "object") {
            const prefillUser = {
              value: String(getValue(applyDelegatedTo, "id", "")),
              label:
                getValue(applyDelegatedTo, "name", "") ||
                `${getValue(applyDelegatedTo, "first_name", "")} ${getValue(
                  applyDelegatedTo,
                  "last_name",
                  ""
                )}`.trim(),
              ...applyDelegatedTo,
            };

            setApplyUsers([prefillUser]);
          }
        }

        if (isApprovalAllowed && approvalDelegatedTo) {
          const userId =
            typeof approvalDelegatedTo === "object"
              ? getValue(approvalDelegatedTo, "id", "")
              : approvalDelegatedTo;
          setSelectedApprovalUser(userId);

          // Create a user object from the response data for prefilling
          if (typeof approvalDelegatedTo === "object") {
            const prefillUser = {
              value: String(getValue(approvalDelegatedTo, "id", "")),
              label:
                getValue(approvalDelegatedTo, "name", "") ||
                `${getValue(approvalDelegatedTo, "first_name", "")} ${getValue(
                  approvalDelegatedTo,
                  "last_name",
                  ""
                )}`.trim(),
              ...approvalDelegatedTo,
            };

            setApprovalUsers([prefillUser]);
          }
        }

        if (isTravelDocumentAllowed && travelDocumentDelegatedTo) {
          const userId =
            typeof travelDocumentDelegatedTo === "object"
              ? getValue(travelDocumentDelegatedTo, "id", "")
              : travelDocumentDelegatedTo;
          setSelectedTravelDocumentUser(userId);

          if (typeof travelDocumentDelegatedTo === "object") {
            const prefillUser = {
              value: String(getValue(travelDocumentDelegatedTo, "id", "")),
              label:
                getValue(travelDocumentDelegatedTo, "name", "") ||
                `${getValue(
                  travelDocumentDelegatedTo,
                  "first_name",
                  ""
                )} ${getValue(
                  travelDocumentDelegatedTo,
                  "last_name",
                  ""
                )}`.trim(),
              ...travelDocumentDelegatedTo,
            };

            setTravelDocumentUsers([prefillUser]);
          }
        }

        if (isTravelProfileAllowed && travelProfileDelegatedTo) {
          const userId =
            typeof travelProfileDelegatedTo === "object"
              ? getValue(travelProfileDelegatedTo, "id", "")
              : travelProfileDelegatedTo;
          setSelectedTravelProfileUser(userId);

          if (typeof travelProfileDelegatedTo === "object") {
            const prefillUser = {
              value: String(getValue(travelProfileDelegatedTo, "id", "")),
              label:
                getValue(travelProfileDelegatedTo, "name", "") ||
                `${getValue(
                  travelProfileDelegatedTo,
                  "first_name",
                  ""
                )} ${getValue(
                  travelProfileDelegatedTo,
                  "last_name",
                  ""
                )}`.trim(),
              ...travelProfileDelegatedTo,
            };

            setTravelProfileUsers([prefillUser]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching delegation settings:", error);
    }
  };

  const handleApplyRadioChange = (e: any) => {
    setIsApplyDelegationAllowed(e.target.value === "yes");

    if (e.target.value === "no") {
      setSelectedApplyUser("");
      setApplyUsers([]);
    }
  };

  const handleApprovalRadioChange = (e: any) => {
    setIsApprovalDelegationAllowed(e.target.value === "yes");

    if (e.target.value === "no") {
      setSelectedApprovalUser("");
      setApprovalUsers([]);
    }
  };

  const handleTravelDocumentRadioChange = (e: any) => {
    setIsTravelDocumentDelegationAllowed(e.target.value === "yes");

    if (e.target.value === "no") {
      setSelectedTravelDocumentUser("");
      setTravelDocumentUsers([]);
    }
  };
  const handleTravelProfileRadioChange = (e: any) => {
    setIsTravelProfileDelegationAllowed(e.target.value === "yes");

    if (e.target.value === "no") {
      setSelectedTravelProfileUser("");
      setTravelProfileUsers([]);
    }
  };

  const handleApplyUserChange = (e: any) => {
    let userId = "";

    if (e && typeof e === "object") {
      userId = getValue(e, "value", "");

      if (!userId || isNaN(Number(userId))) {
        userId = getValue(e, "id", "");
      }
    } else if (e) {
      userId = String(e);
    }

    setSelectedApplyUser(userId);
  };

  const handleApprovalUserChange = (e: any) => {
    let userId = "";

    if (e && typeof e === "object") {
      userId = getValue(e, "value", "");

      if (!userId || isNaN(Number(userId))) {
        userId = getValue(e, "id", "");
      }
    } else if (e) {
      userId = String(e);
    }
    setSelectedApprovalUser(userId);
  };

  const handleTravelDocumentUserChange = (e: any) => {
    let userId = "";

    if (e && typeof e === "object") {
      userId = getValue(e, "value", "");

      if (!userId || isNaN(Number(userId))) {
        userId = getValue(e, "id", "");
      }
    } else if (e) {
      userId = String(e);
    }
    setSelectedTravelDocumentUser(userId);
  };
  const handleTravelProfileUserChange = (e: any) => {
    let userId = "";

    if (e && typeof e === "object") {
      userId = getValue(e, "value", "");

      if (!userId || isNaN(Number(userId))) {
        userId = getValue(e, "id", "");
      }
    } else if (e) {
      userId = String(e);
    }

    setSelectedTravelProfileUser(userId);
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const applyDelegatedToId =
        isApplyDelegationAllowed && selectedApplyUser
          ? Number(selectedApplyUser)
          : null;
      const approvalDelegatedToId =
        isApprovalDelegationAllowed && selectedApprovalUser
          ? Number(selectedApprovalUser)
          : null;
      const travelDocumentDelegatedToId =
        isTravelDocumentDelegationAllowed && selectedTravelDocumentUser
          ? Number(selectedTravelDocumentUser)
          : null;
      const travelProfileDelegatedToId =
        isTravelProfileDelegationAllowed && selectedTravelProfileUser
          ? Number(selectedTravelProfileUser)
          : null;

      const payload = {
        is_apply_delegation_active: isApplyDelegationAllowed,
        apply_delegated_to: applyDelegatedToId,
        is_approval_delegation_active: isApprovalDelegationAllowed,
        approval_delegated_to: approvalDelegatedToId,
        is_travel_document_delegation_active: isTravelDocumentDelegationAllowed,
        travel_document_delegated_to: travelDocumentDelegatedToId,
        is_travel_profile_delegation_active: isTravelProfileDelegationAllowed,
        travel_profile_delegated_to: travelProfileDelegatedToId,
      };

      const response = await updateUserDelegate(userId, payload);

      if (response && response.statusCode === 200) {
        toast.success(
          response.message || "Delegation settings updated successfully"
        );
      } else {
        toast.error("Something went wrong while updating delegation");
      }
    } catch (error) {
      console.error("Error updating delegation settings:", error);
      toast.error("Failed to update delegation settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <AdminNavigation
        id={userId}
        url="/admin/user-controls/users"
        title=""
        permissions={props.permissions || ["update"]}
        hideActionButtons={false}
        hideHeaderMenu={false}
        isLoading={saving}
        handleSubmit={handleSubmit}
        inviteLink={props.inviteLink}
        hideCancel={true}
      />

      <div className="dashboard-wrapper">
        <div className="container-fluid d-flex justify-content-center">
          <div
            className="basic-information_container client-travel-profile-wrap"
            style={{ maxWidth: "800px", width: "100%", marginLeft: "175px" }}
          >
            <div className="checkpoint-active-details-wrapper__form-wrapper">
              <div className="checkpoint-active-details-wrapper__form-content">
                <div className="text-center mb-4">
                  <h3 className="client-travel-profile_main-title">
                    Delegation Settings
                  </h3>
                  <div className="info-alert">
                    Configure delegation settings to allow another user to
                    manage this user's account
                  </div>
                </div>

                <div
                  className="user-details-wrapper__form user-details-wrapper__form--org-profile client-travel-profile-form-wrapper"
                  style={{ marginTop: "24px" }}
                >
                  {/* Apply Delegation Row */}
                  <div className="client-travel-profile-labelfield-wrap mb-4">
                    <label className="form-label-error mb-2 d-block">
                      Allow Application Delegation{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 align-items-center justify-content-center">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="apply-delegation-yes"
                          name="applyDelegationAllowed"
                          value="yes"
                          checked={isApplyDelegationAllowed === true}
                          onChange={handleApplyRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="apply-delegation-yes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="apply-delegation-no"
                          name="applyDelegationAllowed"
                          value="no"
                          checked={isApplyDelegationAllowed === false}
                          onChange={handleApplyRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="apply-delegation-no"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="client-travel-profile-labelfield-wrap mb-4">
                    <label className="form-label-error">
                      Delegate Applications To{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <SingleSelectSearchDropdown
                      label={"label"}
                      name="applyUsers"
                      value={selectedApplyUser}
                      onChange={(e: any) => {
                        handleApplyUserChange(e);
                      }}
                      data={applyUsers}
                      lookup_api={"users"}
                      lookup_id={selectedApplyUser}
                      disabled={
                        !isApplyDelegationAllowed || applyLoading || saving
                      }
                    />
                  </div>

                  {/* Approval Delegation Row */}
                  <div className="client-travel-profile-labelfield-wrap mb-4">
                    <label className="form-label-error mb-2 d-block">
                      Allow Approval Delegation{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 align-items-center justify-content-center">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="approval-delegation-yes"
                          name="approvalDelegationAllowed"
                          value="yes"
                          checked={isApprovalDelegationAllowed === true}
                          onChange={handleApprovalRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="approval-delegation-yes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="approval-delegation-no"
                          name="approvalDelegationAllowed"
                          value="no"
                          checked={isApprovalDelegationAllowed === false}
                          onChange={handleApprovalRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="approval-delegation-no"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Approval Users Dropdown */}
                  <div className="client-travel-profile-labelfield-wrap">
                    <label className="form-label-error">
                      Delegate Approvals To{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <SingleSelectSearchDropdown
                      label={"label"}
                      name="approvalUsers"
                      value={selectedApprovalUser}
                      onChange={(e: any) => {
                        handleApprovalUserChange(e);
                      }}
                      placeholder={"Delegate Approvals To"}
                      width={"100%"}
                      lookup_api={"users"}
                      lookup_id={selectedApprovalUser}
                      disabled={
                        !isApprovalDelegationAllowed ||
                        approvalLoading ||
                        saving
                      }
                    />
                  </div>

                  {/* Travel Document Delegation Row */}
                  <div className="client-travel-profile-labelfield-wrap mb-4 mt-4">
                    <label className="form-label-error mb-2 d-block">
                      Allow Travel Document Delegation{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 align-items-center justify-content-center">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="travel-document-delegation-yes"
                          name="travelDocumentDelegationAllowed"
                          value="yes"
                          checked={isTravelDocumentDelegationAllowed === true}
                          onChange={handleTravelDocumentRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="travel-document-delegation-yes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="travel-document-delegation-no"
                          name="travelDocumentDelegationAllowed"
                          value="no"
                          checked={isTravelDocumentDelegationAllowed === false}
                          onChange={handleTravelDocumentRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="travel-document-delegation-no"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="client-travel-profile-labelfield-wrap">
                    <label className="form-label-error">
                      Delegate Travel Documents To{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <SingleSelectSearchDropdown
                      label={"label"}
                      name="travelDocumentUsers"
                      value={selectedTravelDocumentUser}
                      onChange={(e: any) => {
                        handleTravelDocumentUserChange(e);
                      }}
                      placeholder={"Delegate Travel Documents To"}
                      width={"100%"}
                      lookup_api={"users"}
                      lookup_id={selectedTravelDocumentUser}
                      disabled={
                        !isTravelDocumentDelegationAllowed ||
                        travelDocumentLoading ||
                        saving
                      }
                    />
                  </div>

                  {/* Travel Profile Delegation Row */}
                  <div className="client-travel-profile-labelfield-wrap mb-4 mt-4">
                    <label className="form-label-error mb-2 d-block">
                      Allow Travel Profile Delegation{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4 align-items-center justify-content-center">
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="travel-profile-delegation-yes"
                          name="travelProfileDelegationAllowed"
                          value="yes"
                          checked={isTravelProfileDelegationAllowed === true}
                          onChange={handleTravelProfileRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="travel-profile-delegation-yes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          id="travel-profile-delegation-no"
                          name="travelProfileDelegationAllowed"
                          value="no"
                          checked={isTravelProfileDelegationAllowed === false}
                          onChange={handleTravelProfileRadioChange}
                          style={{ marginTop: "0" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="travel-profile-delegation-no"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="client-travel-profile-labelfield-wrap">
                    <label className="form-label-error">
                      Delegate Travel Profile To{" "}
                      <span className="text-danger">*</span>
                    </label>

                    <SingleSelectSearchDropdown
                      label={"label"}
                      name="travelProfileUsers"
                      value={selectedTravelProfileUser}
                      onChange={(e: any) => {
                        handleTravelProfileUserChange(e);
                      }}
                      placeholder={"Delegate Travel Profile To"}
                      width={"100%"}
                      lookup_api={"users"}
                      lookup_id={selectedTravelProfileUser}
                      disabled={
                        !isTravelProfileDelegationAllowed ||
                        travelProfileLoading ||
                        saving
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default UserDelegation;
